export default "__VITE_ASSET__tBIsRyes__"